import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
    Action,
    createFeatureSelector,
    createReducer,
    createSelector,
    on
} from '@ngrx/store';
import { IAuthorizedTask } from '../IAuthorizedTask';
import * as IAuthorizedTaskActions from './iauthorized-task.actions';

export const iAuthorizedTasksFeatureKey = 'iAuthorizedTasks';

export interface State extends EntityState<IAuthorizedTask> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IAuthorizedTask> =
    createEntityAdapter<IAuthorizedTask>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const iAuthorizedTaskReducer = createReducer(
    initialState,
    on(IAuthorizedTaskActions.addAuthorizedTask, (state, action) =>
        adapter.addOne(action.authorizedTask, state)
    ),
    on(IAuthorizedTaskActions.upsertAuthorizedTask, (state, action) =>
        adapter.upsertOne(action.authorizedTask, state)
    ),
    on(IAuthorizedTaskActions.addAuthorizedTasks, (state, action) =>
        adapter.addMany(action.authorizedTasks, state)
    ),
    on(IAuthorizedTaskActions.upsertAuthorizedTasks, (state, action) =>
        adapter.upsertMany(action.authorizedTasks, state)
    ),
    on(IAuthorizedTaskActions.updateAuthorizedTask, (state, action) =>
        adapter.updateOne(action.authorizedTask, state)
    ),
    on(IAuthorizedTaskActions.updateAuthorizedTasks, (state, action) =>
        adapter.updateMany(action.authorizedTasks, state)
    ),
    on(IAuthorizedTaskActions.deleteAuthorizedTask, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(IAuthorizedTaskActions.deleteAuthorizedTasks, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(IAuthorizedTaskActions.loadAuthorizedTasks, (state, action) =>
        adapter.setAll(action.authorizedTasks, state)
    ),
    on(IAuthorizedTaskActions.clearAuthorizedTasks, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return iAuthorizedTaskReducer(state, action);
}
const localState = createFeatureSelector<State>(iAuthorizedTasksFeatureKey);
export const getEntities = createSelector(localState, x => x.entities);
export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(localState);
